(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '@auth0/auth0-spa-js'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('@auth0/auth0-spa-js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.auth0SpaJs);
    global.client = mod.exports;
  }
})(this, function (exports, _auth0SpaJs) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });


  // get the top-level domain to use for the authenticated cookie
  // this is necessary for apps that span multiple subdomains
  // e.g., account.pga.org and jobs.pga.org should share the same cookie set on the ".pga.org" domain
  var getCookieDomain = function getCookieDomain() {
    var hostname = window && window.location && window.location.hostname;
    if (!hostname) return;
    if (hostname === 'localhost') return;
    var parts = hostname.split('.');
    if (parts.length <= 2) return;
    return '.' + parts.slice(parts.length - 2).join('.');
  };

  var auth0 = new _auth0SpaJs.Auth0Client({
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      redirect_uri: window && window.location && window.location.origin
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    cookieDomain: getCookieDomain()
  });

  exports.default = auth0;
});